import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps } from '@mui/material';
import { Children, cloneElement, ReactElement, ReactNode } from 'react';
import { DrawerHeader, DrawerHeaderProps } from './DrawerHeader';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  anchor?: MuiDrawerProps['anchor'];
  children?: ReactNode;
  testId?: string;
  disableEnforceFocus?: boolean;
  customWidth?: number;
}

/**
 * Drawer is a Mui Drawer with e2m theming.
 */
export function Drawer({
  open,
  onClose,
  anchor = 'right',
  testId,
  children,
  disableEnforceFocus,
  customWidth,
}: Readonly<DrawerProps>): ReactElement<DrawerProps> {
  return (
    <MuiDrawer
      disableEnforceFocus={disableEnforceFocus}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
        '& .MuiDrawer-paper': {
          width: customWidth ? `${customWidth}` : '530px',
          maxWidth: '100vw',
          maxHeight: '100vh',
          display: 'flex',
          overflowY: 'visible',
        },
      }}
      open={open}
      onClose={onClose}
      anchor={anchor}
      onClick={(event) => event.stopPropagation()}
      data-testid={testId}
    >
      {Children.map(children, (child: ReactNode) => {
        if (child && typeof child === 'object' && 'type' in child && child.type === DrawerHeader) {
          return cloneElement(child as ReactElement<DrawerHeaderProps>, { onClose });
        }
        return child;
      })}
    </MuiDrawer>
  );
}
